(ns practitest.frontend.components.license-blocked-modal
  (:require
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.license.events :as license-events]
   [re-frame.core :as re-frame]))

(defn license-blocked-modal
  [container]
  (let [license-blocked? @(re-frame/subscribe [::license-events/license-blocked?])
        reason @(re-frame/subscribe [::license-events/license-blocked-reason])]
    [modal/bootstrap-modal
     {:is-open? license-blocked?
      :class "force-modal"
      :close-button? false
      :centered? true
      :container-ref container
      :on-request-close #()}
     
     (get-translation "license_blocked.modal.title" "Session Inactive")

     (if (= "admin_request" reason)
       [:div.text-center
        [:div
         (get-translation "license_blocked.modal.admin-request"
                          "You've been logged out by an account owner to free a concurrent seat. Please try logging in again later.")]]
       [:div.text-center
        (get-translation "license_blocked.modal.session-expired"
                         "Your session expired due to inactivity.")
        [:br]
        (get-translation "license_blocked.modal.click-below"
                         "Please log in again to continue.")])

     (when-not (= "admin_request" reason)
       [:div.d-flex.justify-content-center
        [buttons/button
         {:primary? true
          :on-click #(dom/reload!)
          :test-id "blocked-license-modal-button"
          :text (get-translation "license_blocked.modal.login-button" "Go to Login")}]])]))
